import axios, { AxiosError } from "axios";
import { DAIKING_API } from "../config/globalVariables";

/**
 * Authenticated axios instance for the Daikin backend API.
 * Uses the same JWT-from-localStorage pattern as authClient.
 */
export const apiClient = axios.create({
  baseURL: (DAIKING_API || "").replace(/\/$/, ""),
  timeout: 30000,
});

// Request interceptor — attach JWT Bearer token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwtToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const lang = localStorage.getItem("i18nextLng") || "tr";
    config.headers["Accept-Language"] = lang;
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor — redirect on 401
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error instanceof AxiosError && error.response?.status === 401) {
      localStorage.removeItem("jwtToken");
      localStorage.removeItem("aadToken");
      window.location.href = "/";
      return Promise.reject(new Error("Unauthorized"));
    }
    return Promise.reject(error);
  },
);
